import { SHOW_MODAL as type } from './';

export default payload => ({ type, payload });
